// extracted by mini-css-extract-plugin
module.exports = {"container":"Owner_container__1-lcq","page":"Owner_page__P-_sn","section":"Owner_section__89mnr"};